import type { SupportChatFeatureConfig } from './type';
import { SupportChatExternalAuthorizationMethod, SupportChatLanguage } from './type';

export const supportChat: Partial<SupportChatFeatureConfig> = {
    channelId: 'george-eboe-cc',
    externalAuthorizationMethod: SupportChatExternalAuthorizationMethod.TOKEN_EXCHANGE,
    fallbackLanguage: SupportChatLanguage.DE,
    languagePackage: 'george-at',
    supportedLanguages: [SupportChatLanguage.EN, SupportChatLanguage.DE],
    displayChatStatus: true,
    proactiveChatChannelId: 'heygeorge-at-web',
};
